'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NoWrap = exports.Link = exports.Text = exports.Bold = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _fontWeight = require('../helpers/font-weight');

var _typography = require('../helpers/typography');

var _theme = require('../config/data/theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var Bold = exports.Bold = _styledComponents2.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: ", ";\n"], ["\n  font-weight: ", ";\n"])), function (_a) {
    var size = _a.size;
    return (0, _fontWeight.getFontWeight)(size);
});
var Text = exports.Text = _styledComponents2.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: ", "\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  color: ", ";\n    text-transform: ", "\n    \n  ", "\n"], ["\n  text-align: ", "\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  color: ", ";\n    text-transform: ", "\n    \n  ", "\n"])), function (_a) {
    var textAlign = _a.textAlign;
    return textAlign || 'left';
}, function (_a) {
    var fontSize = _a.fontSize;
    return (0, _typography.getFontSize)(fontSize);
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return (0, _fontWeight.getFontWeight)(fontWeight);
}, function (_a) {
    var fontSize = _a.fontSize,
        lineHeight = _a.lineHeight;
    return (0, _typography.getLineHeight)(fontSize, lineHeight);
}, function (_a) {
    var color = _a.color;
    return color && _theme.colors[color] ? _theme.colors[color] : _theme.colors.black3;
}, function (_a) {
    var textTransform = _a.textTransform;
    return textTransform || 'none';
}, function (_a) {
    var ellipsis = _a.ellipsis;
    return ellipsis && (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      width: 100%;\n      overflow: hidden;\n    "], ["\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      width: 100%;\n      overflow: hidden;\n    "])));
});
var Link = exports.Link = _styledComponents2.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.8;\n  }\n"], ["\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.8;\n  }\n"])));
var NoWrap = exports.NoWrap = _styledComponents2.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=typography.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/styles/typography.js
// module id = 285
// module chunks = 0